import React from "react";
import Sidebar from "../../components/app/Sidebar";
import { Bars3BottomLeftIcon, BellIcon } from "@heroicons/react/24/outline";
import { Outlet } from "react-router-dom";
import { openSidebarMobile } from "../../store/slices/sidebarSlice";
import { useDispatch } from "react-redux";
import SidebarMobile from "../../components/app/SidebarMobile";
import BreadCrum from "../../components/BreadCrum";

export default function App() {
  const dispatch = useDispatch();
  return (
    <main className="flex overflow-hidden h-screen">
      <Sidebar />
      <SidebarMobile />
      <main className="w-full scrollbar-hide overflow-scroll col-span-6 sm:col-span-4">
        <header className="sticky top-0 left-60 bg-yellow-200 py-3 px-4 h-16 z-20">
          <div className="flex justify-between items-center">
            <Bars3BottomLeftIcon
              className="w-8 text-yellow-900 sm:hidden cursor-pointer"
              onClick={() => dispatch(openSidebarMobile())}
            />
            <p className="text-xl text-yellow-900">Dashboard</p>
            <BellIcon className="w-8 text-yellow-900 cursor-pointer" />
          </div>
        </header>
        <div className="px-6  py-8 ">
          <BreadCrum />
          <div className="px-4">
            <Outlet />
          </div>

          {/* <div className="max-w-4xl mx-auto">
            <Outlet />
          </div> */}
        </div>
      </main>
    </main>
  );
}
